import { SbsPlayerGlobal } from '../../common';
import { loadCookie } from '../../utils/cookie';

import { importScript } from '../../utils';
import { getUUID, getTID } from '../../utils/advertisements';

import SbsPlayerLogger from '../../utils/logger';

/**
  추천 서비스 클라이언트 로그
*/
class SbsUserConnection {
  constructor() {
    this.seq = 0;
    this.userid = null;
    this.uno = null;
    this.tid = null;
    this.video = null;
    this._event = {
      initialized: () => {
        console.log(`initialized.`);
      },
      failed: () => {
        console.log(`failed.`);
      },
    };
  }

  get event() {
    return this._event;
  }
  set event(event) {
    this._event = event;
  }

  init(video) {
    try {
      console.log('SbsUserConnection init');
      const { info, login_info, ad, ad_25, ad_30 } = SbsPlayerGlobal.state.data;
      if (info.playon_yn && info.playon_yn === 'Y') {
        console.log('SbsUserConnection passed in playon');
        return;
      }

      const smrAdVersion = (ad?.smr_ad_version || '2.5').replace(/\./g, '');
      const ad_smr = smrAdVersion === '25' ? ad_25 : ad_30;

      this.uuid = getUUID(ad_smr);
      this.tid = getTID(ad_smr);
      this.userid = loadCookie('SBS_USER_ID');
      this.uno = loadCookie('SBS_UNO');
      this.video = video;

      // * S회원일 때만 동작
      if (!login_info.is_s_member) {
        return false;
      }

      // * concurrent_block.json 상태에 따라 처리
      fetch(
        `https://${
          SbsPlayerGlobal.development
            ? 's3.ap-northeast-2.amazonaws.com/dev.static.cloud.sbs.co.kr'
            : 'static.cloud.sbs.co.kr'
        }/userconnect/concurrent_block.json`,
        {
          method: 'GET',
          headers: new Headers({
            'Content-Type': 'application/json;charset=UTF-8',
          }),
        }
      )
        .then((response) => {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          return response.json();
        })
        .then((fetchedBlock) => {
          console.log('#### fetchedBlock', JSON.stringify(fetchedBlock));

          if (fetchedBlock && fetchedBlock.web_use_userconnection_yn === 'Y') {
            this._event.initialized();
          }
        })
        .catch((error) => {
          console.error('Fetch error:', error);
        });
    } catch (error) {
      console.log(error);
    }
  }

  /**
   * SBS동시시청방지 - setInterval
   */
  setInterval() {
    try {
      //console.log('==> check.', this.seq, this.userid, this.uuid, this.tid, this.video.paused);
      //console.log('동시시청방지 전송 인터벌 10(s)');
      this.interval = setInterval(() => {
        if (this.userid && this.tid && !this.video.paused) {
          const response = fetch(
            `https://${
              SbsPlayerGlobal.development ? 'dev.' : ''
            }apis.sbs.co.kr/play-api/1.0/userconnect/web/player`,
            {
              method: 'post',
              headers: new Headers({
                'Content-Type': 'application/json;charset=UTF-8',
              }),
              body: JSON.stringify({
                USER_ID: this.uno.toString(),
                UUID: this.uuid.toString(),
                PLATFORM: 'web',
                SEQ: parseInt(this.seq),
              }),
            }
          );
          const result = response
            .then((res) => {
              if (res.status === 403) {
                throw new Error(`${res.status}`);
              }
              if (res.ok) {
                return res.json();
              }
            })
            .then((data) => {
              this.seq++;
              return data;
            })
            .catch((error) => {
              if (error.message === '403') {
                this._event.failed();
              }
            });
        }
      }, 10_000);
    } catch (error) {
      console.error('SbsUserConnection', error);
    }
  }
}

export default SbsUserConnection;
